import React from "react";
import Tr from "../../common/table/tr";
import Td from "../../common/table/td";
import { TabelaCicloSazonal } from "./TabelaCicloSazonal";

export function IndicadorDemandasAtingidasUltrapassagem(props) {
    if (!props.item.id) {
        return (
            <>
                <div title={props.titleGrupoFaturamentoTipoMedicao} style={{ fontWeight: "bold", color: "#000", display: "flex", alignItems: "center", justifyContent: "center" }}>
                    {props.grupoFaturamentoTipoMedicao}
                </div>
                <div
                    style={{
                        backgroundColor: props.item.id_grupo_faturamento == 3 ? "#000" : "#ef2028",
                        color: "#ffffff",
                        padding: 5,
                        borderRadius: "0.3rem",
                        textAlign: "center",
                    }}
                >
                    <div style={{ width: "100%", minWidth: 150 }}>A UC não possui contrato de demanda</div>
                </div>
            </>
        );
    }

    const iconesAtingidas = new Array(3).fill(null).map((_, i) => {
        return (
            <div
                key={i}
                style={{
                    width: 25,
                    height: 30,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    backgroundColor: i + 1 <= props.item.atingidas ? "transparent" : "#efefef",
                }}
            >
                <i
                    style={{
                        color: i + 1 <= props.item.atingidas ? "#006224" : "#E22",
                        fontSize: "0.8rem",
                    }}
                    className={i + 1 <= props.item.atingidas ? "fas fa-check" : "fas fa-minus"}
                ></i>
            </div>
        );
    });

    return props.item.contrato_demanda_sazonal ? (
        <table>
            <tbody>
                <Tr style={{ height: 125 }}>
                    <Td minWidth={120} color={props.item.atingidas >= 2 ? "#fff" : "#000"} backgroundColor={"#fff0"} alignCenter>
                        <div style={{ fontWeight: "bold", color: props.color || "#000" }}> Contrato Sazonal</div>
                        <div title={props.titleGrupoFaturamentoTipoMedicao} style={{ fontWeight: "bold", color: props.color || "#000" }}>
                            {props.grupoFaturamentoTipoMedicao}
                        </div>
                        <div
                            style={{
                                display: "flex",
                                flexWrap: "nowrap",
                                fontWeight: "bold",
                                backgroundColor: "#FFF",
                                width: props.minWidth || "max-content",
                                border: `3px solid ${props.item.atingidas >= 3 ? "#0bf97f" : "#000"}`,
                            }}
                        >
                            <div
                                style={{
                                    margin: 3,
                                    display: "flex",
                                    flexWrap: "nowrap",
                                    fontWeight: "bold",
                                    backgroundColor: props.item.atingidas > 0 ? "#6affa2" : "#FFF",
                                    width: props.minWidth || "max-content",
                                    color: props.item.atingidas >= 3 ? "#0f6b31" : "#000",
                                }}
                            >
                                <span style={{ padding: "4px 10px" }}>{props.item.atingidas}</span> {iconesAtingidas}
                            </div>
                        </div>
                        <TabelaCicloSazonal color={props.color} sazonalidadeDiferenteDaUC={props.sazonalidadeDiferenteDaUC} item={props.item} minWidth={props.minWidth} />
                    </Td>
                    <Td
                        color={"#fff"}
                        title={`Total de ultrapassagens:${parseInt(props.item.ultrapassagens || 0)}`}
                        minWidth={40}
                        backgroundColor={parseInt(props.item.ultrapassagens) ? "#fa3c3c" : "black"}
                        borderBottom={props.ultimaLinha ? `1px solid ${parseInt(props.item.ultrapassagens) ? "#fa3c3c" : "black"}` : null}
                        alignCenter
                    >
                        <div
                            style={{
                                display: "flex",
                                flexGrow: 1,
                                flexDirection: "column",
                                borderRadius: 3,
                            }}
                        >
                            <div style={{ fontSize: "1.4rem", fontWeight: "bold" }} className="info-box-icon">
                                <i className="fas fa-angle-double-up"></i>
                            </div>
                            <div style={{ fontSize: "0.9rem", fontWeight: "bold" }} className="info-box-number">
                                {props.item.ultrapassagens}
                            </div>
                        </div>
                    </Td>
                </Tr>
            </tbody>
        </table>
    ) : (
        <>
            <div style={{ fontWeight: "bold", color: props.color || "#000", display: "flex", alignItems: "center", justifyContent: "center" }}>Contrato Não Sazonal</div>
            <div title={props.titleGrupoFaturamentoTipoMedicao} style={{ fontWeight: "bold", color: props.color || "#000", display: "flex", alignItems: "center", justifyContent: "center" }}>
                {props.grupoFaturamentoTipoMedicao}
            </div>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                <div
                    style={{
                        margin: 0,
                        flexDirection: "column",
                        alignItems: "center",
                        padding: "5px 5px 0px 5px",
                        minHeight: "fit-content",
                    }}
                    className="info-box bg-green"
                    title="Demandas Atingidas sem Ultrapassagens"
                >
                    <span
                        className="info-box-icon"
                        style={{
                            width: window.innerWidth < 576 ? 20 : 70,
                            fontSize: "1.3rem",
                        }}
                    >
                        <i className="fas fa-angle-up"></i>
                    </span>
                    <span style={{ margin: 0 }} className="info-box-number">
                        {props.item.atingidas - (props.item.ultrapassagens || 0) || 0}
                    </span>
                </div>
                <div
                    style={{
                        margin: 0,
                        flexDirection: "column",
                        alignItems: "center",
                        padding: "5px 5px 0px 5px",
                        minHeight: "fit-content",
                    }}
                    className="info-box bg-red"
                    title="Demandas Atingidas com Ultrapassagens"
                >
                    <span
                        className="info-box-icon"
                        style={{
                            width: window.innerWidth < 576 ? 20 : 70,
                            fontSize: "1.3rem",
                        }}
                    >
                        <i className="fas fa-angle-double-up"></i>
                    </span>
                    <span style={{ margin: 0 }} className="info-box-number">
                        {props.item.ultrapassagens || 0}
                    </span>
                </div>
            </div>
            <TabelaCicloSazonal sazonalidadeDiferenteDaUC={props.sazonalidadeDiferenteDaUC} item={props.item} color={props.color} />
        </>
    );
}
